// ############################################################
/**
 * Contains the model for event activity
 */
// ############################################################

import { IEventActivityInterface } from './event-activity.interface'
import { ModelBaseModel } from '../model-base/model-base.model'
import { IModelBaseModel } from '../model-base/model-base.interface'

// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
/**
 * Holds the models to store event activity
 */
export class EventActivityModel
  extends ModelBaseModel<IEventActivityInterface>
  implements IModelBaseModel
{
  /** Version of the model */
  public v: IEventActivityInterface['v']
  /** Unique ID for the activity */
  public id: IEventActivityInterface['id']
  /** The ID of the event this activity belongs to */
  public eventId: IEventActivityInterface['eventId']
  /** The ID of the user who performed the action (or 'system' for system actions) */
  public userId: IEventActivityInterface['userId']
  /** The display name of the user who performed the action */
  public userName: IEventActivityInterface['userName']
  /** The full name of the user who performed the action */
  public userFullName: IEventActivityInterface['userFullName']
  /** Optional URL of the user's avatar */
  public userAvatar: IEventActivityInterface['userAvatar']
  /** Brief description of the action performed */
  public action: IEventActivityInterface['action']
  /** Optional additional details about the action */
  public details: IEventActivityInterface['details']
  /** Timestamp when the activity occurred */
  public activityTime: IEventActivityInterface['activityTime']
  /** Whether this is a system-generated activity */
  public isSystem: IEventActivityInterface['isSystem']
  /** Creation timestamp */
  public created: IEventActivityInterface['created']
  /** Last modification timestamp */
  public modified: IEventActivityInterface['modified']
  /** Additional ngrams for the action */
  public actionNgrams: IEventActivityInterface['actionNgrams']

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * Creates an instance of the model
   */
  constructor(obj?: IEventActivityInterface) {
    super()

    // Define default values
    this.v = 1
    this.id = obj?.id || ''
    this.eventId = obj?.eventId || ''
    this.userId = obj?.userId || ''
    this.userName = obj?.userName || ''
    this.userFullName = obj?.userFullName || ''
    this.userAvatar = obj?.userAvatar || ''
    this.action = obj?.action || ''
    this.details = obj?.details || ''
    this.activityTime = this.utcTimestamp({
      key: 'activityTime',
      value: obj?.activityTime || new Date(),
      isTimestamp: true,
    })
    this.isSystem = obj?.isSystem || false
    this.created = this.utcTimestamp({
      key: 'created',
      value: obj?.created,
      isTimestamp: true,
    })
    this.modified = this.utcTimestamp({
      key: 'modified',
      value: obj?.modified,
      isTimestamp: true,
    })
    this.actionNgrams = obj?.actionNgrams || []
  }

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * Creates a model from a Firestore document
   */
  static fromFirestoreDoc(doc: any) {
    if (!doc || !doc.exists) {
      return null
    }

    const data = doc.data()
    if (!data) {
      return null
    }

    return EventActivityModel.fromObject({
      ...data,
      id: doc.id,
    })
  }

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * Creates a model from an object
   */
  static fromObject(obj: any) {
    if (!obj) {
      return null
    }

    return new EventActivityModel(obj)
  }
}
